"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeBreakpointSizePropTypes = void 0;

var _reactDesc = require("react-desc");

var _breakpointObserver = require("@decisiv/breakpoint-observer");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// eslint-disable-next-line import/prefer-default-export
var makeBreakpointSizePropTypes = function makeBreakpointSizePropTypes() {
  return {
    size: _reactDesc.PropTypes.oneOf(['_'].concat(_toConsumableArray(Object.keys(_breakpointObserver.sizes)))).description('Defines the breakpoint to use (for use in reactive design).')
  };
};

exports.makeBreakpointSizePropTypes = makeBreakpointSizePropTypes;